<template>
  <v-dialog v-model="dialog" width="360">
    <v-card class="csv-download">
      <h5 class="pa-3">
        観測所データ CSVダウンロード
      </h5>
      <div class="d-flex pa-3">
        <datetime
          type="date"
          v-model="startDate"
          :max-datetime="endDate"
          class="datetime-area"
        >
        </datetime>
        <div class="mx-2">〜</div>
        <datetime
          type="date"
          v-model="endDate"
          :max-datetime="limitDate"
          class="datetime-area"
        >
        </datetime>
      </div>

      <v-card tile flat class="pa-3">
        <v-simple-table>
          <tbody>
            <tr>
              <td class="py-1" style="width: 200px">雨量観測拠点</td>
              <td>
                <v-btn small @click="download(1)" :disabled="disabled">
                  ダウンロード
                </v-btn>
              </td>
            </tr>
            <tr>
              <td class="py-1" style="width: 200px">マンホール観測拠点</td>
              <td>
                <v-btn small @click="download(45)" :disabled="disabled">
                  ダウンロード
                </v-btn>
              </td>
            </tr>
            <tr>
              <td class="py-1" style="width: 200px">水位観測拠点</td>
              <td>
                <v-btn small @click="download(4)" :disabled="disabled">
                  ダウンロード
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-card height="40" flat class="pt-5 px-3">
          <div v-if="disabled" class="caption indigo--text">
            CSVデータ作成中...
          </div>
        </v-card>
      </v-card>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { OBSERVATORY } from "../enums/Type";
import axios from "axios";
import { apiConfig } from "../config";
export default {
  name: "CsvDownload",
  props: {
    dialog: Boolean
  },
  data() {
    return {
      limitDate: moment.utc().toISOString(),
      startDate: moment.utc().toISOString(),
      endDate: moment.utc().toISOString(),
      disabled: false
    };
  },
  computed: {
    observatories() {
      return this.$store.getters.observatories;
    },
    rains() {
      return this.observatories.filter(
        obs =>
          obs.type === OBSERVATORY.RAIN.code &&
          ([
            "21269_4",
            "21269_5",
            "21269_6",
            "3073_20",
            "3073_75",
            "3073_42",
            "3073_76",
            "3073_69"
          ].includes(obs.id) ||
            obs.id.startsWith("99_12217_2_"))
      );
    },
    manholes() {
      return this.observatories.filter(
        obs => obs.type === OBSERVATORY.MANHOLE.code
      );
    },
    stages() {
      const arr = this.$store.getters.observatories;
      return arr.filter(
        obs =>
          obs.type === OBSERVATORY.STAGE.code &&
          [
            "21279_17",
            "21279_60",
            "21259_31",
            "21259_41",
            "21269_42",
            "21269_30",
            "21269_24",
            "21269_11",
            "3073_105",
            "3073_82",
            "3073_43",
            "3073_85"
          ].includes(obs.id)
      );
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },

    getTargetCsv(target) {
      const obsType = target.obs.type;
      const reals = target.reals;
      const timeseries = target.timeseries;

      let csv = "";
      if (obsType === OBSERVATORY.RAIN.code) {
        csv = "観測日時,10分雨量,累計雨量";
      } else {
        csv = "観測日時,水位";
      }
      timeseries.forEach(ts => {
        const line = {
          date: moment
            .utc(ts, "YYYY/MM/DD HH:mm")
            .add(9, "hours")
            .format("YYYY/MM/DD HH:mm"),
          min10: "",
          total: "",
          level: ""
        };

        const row = reals.find(r => r.date === ts);
        if (row !== undefined) {
          if (row.min10 !== undefined) {
            line.min10 = row.min10.toFixed(2);
          }
          if (row.total !== undefined) {
            line.total = row.total.toFixed(2);
          }
          if (row.level !== undefined) {
            line.level = row.level.toFixed(2);
          }
        }
        if (obsType === OBSERVATORY.RAIN.code) {
          csv += `\r\n${line.date},${line.min10},${line.total}`;
        } else {
          csv += `\r\n${line.date},${line.level}`;
        }
      });

      return {
        name: target.obs.name,
        csv: csv
      };
    },

    async createCsv(obsType, timeseries, start, end) {
      let rows = [];
      if (obsType === OBSERVATORY.RAIN.code) {
        rows = this.rains;
      } else if (obsType === OBSERVATORY.MANHOLE.code) {
        rows = this.manholes;
      } else if (obsType === OBSERVATORY.STAGE.code) {
        rows = this.stages;
      }

      const obsReals = [];
      const processes = rows.map(async obs => {
        const params = {
          type: obs.type,
          id: obs.id,
          date1: start.format("YYYY/MM/DD HH:mm"),
          date2: end.format("YYYY/MM/DD HH:mm")
        };
        if (obs.dynamodb) {
          params.dynamodb = obs.dynamodb;
        }
        return axios
          .get(`${apiConfig.baseUrl}/observatories/reals`, {
            params
          })
          .then(res => {
            obsReals.push({
              obs: obs,
              reals: res.data.reals,
              timeseries: JSON.parse(JSON.stringify(timeseries))
            });
          });
      });
      await Promise.all(processes);

      const targets = await Promise.all(
        obsReals.map(target => this.getTargetCsv(target))
      );

      let csvs = [];
      for (const target of targets) {
        const obsName = target.name;
        const targetCsv = target.csv;
        const current = targetCsv.split("\r\n");
        if (obsType === OBSERVATORY.RAIN.code) {
          current.unshift(`場所,${obsName},${obsName}`);
        } else {
          current.unshift(`場所,${obsName}`);
        }
        if (csvs.length === 0) {
          csvs = current;
        } else {
          for (let i = 0; i < current.length; i++) {
            const arr = current[i].split(",");
            csvs[i] = csvs[i] + "," + arr[1];
            if (obsType === OBSERVATORY.RAIN.code) {
              csvs[i] = csvs[i] + "," + arr[2];
            }
          }
        }
      }

      let filename = "";
      if (obsType === OBSERVATORY.RAIN.code) {
        filename += "雨量_";
      } else if (obsType === OBSERVATORY.MANHOLE.code) {
        filename += "マンホール_";
      } else if (obsType === OBSERVATORY.STAGE.code) {
        filename += "水位_";
      }
      filename +=
        start
          .clone()
          .add(10, "hours")
          .format("YYYYMMDD") +
        "_" +
        end
          .clone()
          .add(9, "hours")
          .format("YYYYMMDD") +
        ".csv";

      const csv = csvs.join("\r\n");
      const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
      var elm = document.createElement("a");
      elm.download = filename;
      elm.href = URL.createObjectURL(
        new Blob([bom, csv], { type: "text/csv" })
      );
      elm.dataset.downloadurl = ["text/csv", elm.download, elm.href].join(":");
      elm.click();
    },

    async download(obsType) {
      if (this.disabled === true) {
        return;
      }
      const d1 = moment.utc(this.startDate);
      const d2 = moment.utc(this.endDate);
      if (d1.isAfter(d2) === true) {
        alert("日付範囲を確認してください。");
        return;
      }
      const d = d1.clone().add(31, "days");
      if (d.isSameOrBefore(d2) === true) {
        alert("31日以内で指定して下さい。");
        return;
      }

      this.disabled = true;
      try {
        const start = moment.utc(
          d1.subtract(1, "day").format("YYYYMMDD1451"),
          "YYYYMMDDHHmm"
        );
        const end = moment.utc(d2.format("YYYYMMDD1450"), "YYYYMMDDHHmm");

        const timeseries = [];
        const current = start
          .clone()
          .add(10 - (start.minute() % 10), "minutes");
        while (current.isSameOrBefore(end)) {
          timeseries.push(current.format("YYYY/MM/DD HH:mm"));
          current.add(obsType === OBSERVATORY.MANHOLE.code ? 1 : 10, "minutes");
        }

        await this.createCsv(obsType, timeseries, start, end);

        this.disabled = false;
      } catch (e) {
        this.disabled = false;
        console.error(e);
      }
    }
  }
};
</script>

<style lang="scss">
.csv-download {
  .datetime-area {
    .vdatetime-input {
      cursor: pointer !important;
      padding: 3px;
      background-color: #1976d2 !important;
      width: 140px;
      color: white !important;
      border-radius: 1em;
      text-align: center;
    }
  }
}
</style>
